import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';
import Fragments from '../fragments/fragments';

export const PARTNER_FILE_BULK_PAGED_LIST_QUERY = gql`
  query partnerFileBulkPagedList($pager: PagerInput, $filters: PartnerFileBulkFilterInput) {
    partnerFileBulkPagedList(pager: $pager, filters: $filters) {
      pagination(pager: $pager, filters: $filters) {
        ...pagination
      }
      values {
        ...partnerFileBulk
      }
    }
  }
  ${CommonFragments.pagination}
  ${Fragments.partnerFileBulk}
`;

export const PARTNER_FILE_BULK_LIST_QUERY = gql`
  query partnerFileBulkList($filters: PartnerFileBulkFilterInput) {
    partnerFileBulkList(filters: $filters) {
      ...partnerFileBulk
    }
  }
  ${Fragments.partnerFileBulk}
`;
